import { Modal, Button } from "react-bootstrap";
import React from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
import { PROVIDER_POSITIONS } from "../enum";
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
const basicSchema = Yup.object().shape({
  typeName: Yup.string().required("Type Name is required"),
  pricePerKM: Yup.number().required("Surge Price Per KM is required"),
  surgePricePerKM: Yup.number().required("Price Per KM is required"),
  noOfSeats: Yup.number().required("No Of Seats Per KM is required"),
  status: Yup.string().required("Status is required"),
 file: Yup.mixed().required("Image is required"),
 provider_type: Yup.number().required("Provider Type is required"),
  initialPrice: Yup.number().required("Initial Price is required"),
 minimumDistance: Yup.number().min(0, "Minimum distance must be 0 or greater"),
  maximumDistance: Yup.number().min(Yup.ref('minimumDistance'), "Maximum distance must be greater than or equal to minimum distance").required("Maximum distance is required"),
});

const Add = ({ showModal, hideModal, getVehicleTypes }) => {
  const history = useNavigate();


  const onSubmit = async (values, actions) => {
   await new Promise((resolve) => setTimeout(resolve, 1000));
  addVehicleType(values);
  };


  const { values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit, submitForm } = useFormik({
      initialValues: {
        typeName: "",
        pricePerKM: '',
        surgePricePerKM: '',
        noOfSeats:'',
        file: '',
        status: '',
        provider_type: PROVIDER_POSITIONS.RIDE_PROVIDER,
        initialPrice: '',
        minimumDistance: '',
        maximumDistance: '',
        outOfCityPricePerKM: '',
        outOfCitySurgePricePerKM: '',

      },
      validationSchema: basicSchema,
      onSubmit
    })


  const notifySuccess = () => toast.success('VehicleType Added.', {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  const notifyError = () => toast.error('Something went wrong ...', {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  const addVehicleType = async (e) => {
    console.log("emfsdf", e);
    try {

      const bodyFormData = new FormData();
      for (let value in values) {
        bodyFormData.append(value, values[value]);
      }


      const response = await axios.post("/vehicleTypes", bodyFormData);
      history("/vehicleTypes");
      hideModal();
      getVehicleTypes();
      notifySuccess();
      console.log(response.status)
    } catch (error) {
      console.log(error.response)
      if (error.response) {
        notifyError();
      }
    }
  };

  return (

   <form onSubmit={handleSubmit} autoComplete="off" encType="multipart/form-data">


      <Modal
       style={{marginTop: "60px"}}
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        aria-labelledby="contained-modal-title-vcenter"
      >

        <Modal.Header closeButton>
          <Modal.Title>Add Vehicle Type</Modal.Title>
        </Modal.Header>
        <Modal.Body  >
          <div class="row" >
            <div class="col-md-12">
              <div class="card card-primary">


                <div class="card-body">
                  <div class="form-group">
                    <label for="inputName">Type Name</label>
                    <input
                      type="text"
                      name="typeName"
                      value={values.typeName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.typeName && touched.typeName ? "form-control input-error" : "form-control "}

                    />
                    {errors.typeName && touched.typeName && <p className="error">{errors.typeName}</p>}

                  </div>

                  <div class="form-group">
                    <label for="inputName">Price Per KM</label>
                    <input
                      type="number"
                      name="pricePerKM"
                      value={values.pricePerKM}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.pricePerKM && touched.pricePerKM ? "form-control input-error" : "form-control "}

                    />
                    {errors.pricePerKM && touched.pricePerKM && <p className="error">{errors.pricePerKM}</p>}

                  </div>

                  <div class="form-group">
                    <label for="inputName">Surge Price Per KM</label>
                    <input
                      type="number"
                      name="surgePricePerKM"
                      value={values.surgePricePerKM}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.surgePricePerKM && touched.surgePricePerKM ? "form-control input-error" : "form-control "}

                    />
                    {errors.surgePricePerKM && touched.surgePricePerKM && <p className="error">{errors.surgePricePerKM}</p>}

                  </div>

                  <div class="form-group">
                    <label for="inputName">Out-of-City Price Per KM</label>
                    <input
                      type="number"
                      step="0.01"
                      name="outOfCityPricePerKM"
                      value={values.outOfCityPricePerKM}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="form-control"
                      placeholder="Price per KM from Addis to other cities (e.g., Bahir Dar, Hawassa)"
                    />
                  </div>

                  <div class="form-group">
                    <label for="inputName">Out-of-City Surge Price Per KM</label>
                    <input
                      type="number"
                      step="0.01"
                      name="outOfCitySurgePricePerKM"
                      value={values.outOfCitySurgePricePerKM}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="form-control"
                      placeholder="Surge price per KM from Addis to other cities during peak hours"
                    />
                  </div>

                  <div class="form-group">
                    <label for="inputName">No Of Seats</label>
                    <input
                      type="number"
                      name="noOfSeats"
                      value={values.noOfSeats}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.noOfSeats && touched.noOfSeats ? "form-control input-error" : "form-control "}

                    />
                    {errors.noOfSeats && touched.noOfSeats && <p className="error">{errors.noOfSeats}</p>}

                  </div>
                  
                  {/* initial price here */}
                  <div class="form-group">
                    <label for="inputName">Initial Price</label>
                    <input
                      type="number"
                      name="initialPrice"
                      value={values.initialPrice}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.initialPrice && touched.initialPrice ? "form-control input-error" : "form-control "}
                    />
                    {errors.initialPrice && touched.initialPrice && <p className="error">{errors.initialPrice}</p>}
                  </div>


                  <div class="form-group">
                    <label for="minimumDistance">Minimum Distance (KM)</label>
                    <input
                      type="number"
                      step="0.01"
                      name="minimumDistance"
                      value={values.minimumDistance}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.minimumDistance && touched.minimumDistance ? "form-control input-error" : "form-control "}
                      placeholder="Enter minimum billable distance"
                    />
                    {errors.minimumDistance && touched.minimumDistance && <p className="error">{errors.minimumDistance}</p>}
                  </div>

                  <div class="form-group">
                    <label for="maximumDistance">Maximum Distance (KM)</label>
                    <input
                      type="number"
                      step="0.01"
                      name="maximumDistance"
                      value={values.maximumDistance}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.maximumDistance && touched.maximumDistance ? "form-control input-error" : "form-control "}
                      placeholder="Enter maximum billable distance"
                    />
                    {errors.maximumDistance && touched.maximumDistance && <p className="error">{errors.maximumDistance}</p>}
                  </div>

                  <div className="form-group">
                    <label htmlFor="provider_type">Provider Type</label>
                    <select
                      id="provider_type"
                      name="provider_type"
                      className={errors.provider_type && touched.provider_type ? "form-control input-error" : "form-control"}
                      value={values.provider_type}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="">Select Provider Type</option>
                      <option value={PROVIDER_POSITIONS.FIRST_RESPONDER}>First Responder</option>
                      <option value={PROVIDER_POSITIONS.AMBULANCE_PROVIDER}>Ambulance Provider</option>
                      <option value={PROVIDER_POSITIONS.RIDE_PROVIDER}>Ride Provider</option>
                      <option value={PROVIDER_POSITIONS.HOMECARE_PROVIDER}>HomeCare Provider</option>
                    </select>
                    {errors.provider_type && touched.provider_type && <p className="error">{errors.provider_type}</p>}
                  </div>

                  <div className="form-group">
                    <label for="inputStatus">Status</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="status"
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.status && touched.status ? "form-control input-error" : "form-control "}
                    >
                      <option selected>
                        Select Status
                      </option>

                      <option key={"Active"} value={"Active"}>
                        {"Active"}
                      </option>
                      <option key={"Inactive"} value={"Inactive"}>
                        {"Inactive"}
                      </option>

                    </select>
                    {errors.status && touched.status && <p className="error">{errors.status}</p>}

                  </div>

                  <div class="form-group">
                    <label for="exampleInputFile"> Image</label>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFile"
                          name="file"
                          accept='image/*'

                          onChange={(e) =>
                            setFieldValue('file', e.currentTarget.files[0])
                          }
                          className={errors.file && touched.file ? "form-control input-error" : "form-control "}
                        />
                      </div>
                    </div>
                    {errors.file && touched.file && <p className="error">{errors.file}</p>}
                  </div>
                </div>



              </div>
            </div>

          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={hideModal}>
            Cancel
          </Button>

          <button disabled={isSubmitting} onClick={submitForm} className="btn btn-success" type="submit">
            Submit
          </button>

        </Modal.Footer>

      </Modal>
    </form>

  );
};

export default Add;
